/* eslint-disable */
import { getVendor } from '../api.js'

import viewData from './viewData.js'
import cache from '../cache.js'

const CACHE_PATH_CODE = ['vendor', 'codes']
const CACHE_PATH_DATA = ['vendor', 'data']
const CACHE_TIME = 15 * 60 * 1000 // 15 minutes

const _vars = {
  data: undefined
}


// function _getAllCodes() {
//   cache.checkGetMiss(CACHE_PATH_CODE, () => {
//     return getVendor()
//       .then(response => {
//         cache.set(response.data, CACHE_TIME, ...CACHE_PATH_CODE)
//         return response.data
//       })
//   })
// }

// function _getVendor(code) {
//   if (code === undefined) {
//     return cache.checkGetMiss(CACHE_PATH_DATA, () => {
//       return getVendor(/*{ fields: 'all' }*/)
//         .then(response => {
//           cache.set(response.data, CACHE_TIME, ...CACHE_PATH_DATA)
//           return response.data
//         })
//     })
//   }
//   else {
//     return cache.checkGetMiss([...CACHE_PATH_DATA, code], () => {
//       return getVendor(/*{ codes: [code], fields: 'all' }*/)
//         .then(response => {
//           cache.set(response.data, CACHE_TIME, ...CACHE_PATH_DATA, code)
//           return response.data
//         })
//     })
//   }
// }

function populate(data) {
  // cache.set(data, CACHE_TIME, ...CACHE_PATH_DATA)
  _vars.data = data
}

function getSync(id) {
  if (_vars.data === undefined) {
    return undefined
  }
  return _vars.data.find(elem => elem.id === id)
}

function get(id) {
  // cache.checkGetMiss(CACHE_PATH_DATA, () => {
  //   return viewData.getOptionsFromServer()
  // })
  let retPromise = undefined
  if (_vars.data === undefined) {
    _vars.viewPromise = viewData.getOptionsFromServer()

    retPromise = _vars.viewPromise.then(() => {
      return _vars.data.find(elem => elem.id === id)
    })
  }
  else {
    retPromise = Promise.resolve(getSync(id))
  }
  return retPromise
}

function filter(filterIds) {
  let retPromise = undefined
  if (_vars.data === undefined) {
    _vars.viewPromise = viewData.getOptionsFromServer()

    retPromise = _vars.viewPromise.then(() => {
      return _vars.data.filter(elem => filterIds.includes(elem.id))
    })
  }
  else {
    retPromise = Promise.resolve(_vars.data.filter(elem => filterIds.includes(elem.id)))
  }
  return retPromise
}

export default {
  // getAllCodes: _getAllCodes,
  // getVendor: _getVendor,
  populate: populate,
  getSync: getSync,
  get: get,
  filter: filter,
}
